const regexRules = {
    upperCaseOrNumbersOrSpace: 'regex:/^[0-9A-Z ]+$/',
    numbers: 'regex:/^[0-9]+$/',
};

export default regexRules;
